import {
  CachedAudioScrubber as SharedCachedAudioScrubber,
  type CachedAudioScrubberProps as SharedCachedAudioScrubberProps,
} from '@frontend/components';
import { usePreference } from '@frontend/user-preferences';

export type CachedAudioScrubberProps = SharedCachedAudioScrubberProps & {
  persistPlaybackRate?: boolean;
};

export const CachedAudioScrubber = ({ persistPlaybackRate, ...props }: CachedAudioScrubberProps) => {
  const [playbackRate, setPlaybackRate] = usePreference('AudioPlaybackRate');
  const playbackRateOptions = props.playbackRateOptions ?? [0.7, 1, 1.5, 1.7, 2];
  const appliedPlaybackRate = playbackRateOptions.includes(playbackRate) ? playbackRate : 1;

  return (
    <SharedCachedAudioScrubber
      {...props}
      playbackRate={persistPlaybackRate ? appliedPlaybackRate : undefined}
      onPlaybackRateChange={persistPlaybackRate ? setPlaybackRate : undefined}
    />
  );
};
